import { getLogger } from "@shared/logging";
import { LoginProvider } from "../interfaces";
import { Params } from "@angular/router";
import { BackendService } from "src/app/services/backend.service";
import { AuthenticationError, CustomToken } from "../../authnz.service";
import { ExtractErrorFromHTMLPayload, ProxyReceiveError } from "src/classes/PopupCrossOriginDTOProxy";

const log = getLogger("URLTokenAuthProvider")

export class URLTokenAuthProvider {

  private id: string
  private token: string;

  public isLoginTrigger(params: Params): boolean {
    const hasToken = params.hasOwnProperty('token') &&
      typeof params['token'] === 'string';

    if (hasToken) {
      this.token = params['token'];
      log.debug("Token query parameter detected",this.token)
    }
    const hasProviderId = params.hasOwnProperty("ProviderId") &&
      typeof params["ProviderId"] === "string" &&
      params["ProviderId"] === this.id;

    return hasToken && hasProviderId;

  }

  constructor(
    provider: LoginProvider,
    private backendService: BackendService
  ) {
    this.id = provider.id;
  }

  public async signIn():Promise<CustomToken> { 
    try {
      const fireAuthToken = await this.backendService.backendPost('auth/jwt/verify', {},
        {
          token: this.token
        },{
          authenticated: false
        }
      );
      return fireAuthToken.token
    }
    catch (err) {
      let realError = err;
      try {
        realError = ExtractErrorFromHTMLPayload(err.error);
      }
      catch (noe) {
        log.debug("Payload was not HTML", noe)
      }
      if (realError instanceof ProxyReceiveError) {
        throw new AuthenticationError("Token authentication failed", realError.UserFriendlyMessage, realError.referenceCode)
      }
      else {
        throw new AuthenticationError("Token authentication failed")
      }
    }

  } 
}